import {MAIN_ROUTES} from "../routes/mainRoutes";

export const breadcrumbsTranslationUkr = {
  [MAIN_ROUTES.CART]: "Моя корзина",
  [MAIN_ROUTES.CONFIRM_ORDER]: "Оформлення замовлення",
  [MAIN_ROUTES.REFERRAL_STRUCTURE]: "Моя структура",
  [MAIN_ROUTES.FAVOURITES]: "Список вподобаного",
}
